import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SingleSelectKendoGrid from "../../Grid/Selectable/SingleSelectKendoGrid";
import ContactGridColumns from "./ContactGridColumns";
import { ContactOverviewItem } from "./ContactOverviewItem";
import { combinedUrls } from "../../URL/functions";
import { contactUrls } from "../../URL/ApplicationUrls";
import PageHeader from "../../Layout/Header/PageHeader";
import { defaultEditButton } from "../../Grid/Toolbar/DefaultEditButton";
import { createExportButton } from "../../Grid/ExcelExport/CreateExportButton";
import { defaultAddButton } from "../../Grid/Toolbar/DefaultAddButton";
import { AuthorizationPolicies } from "../../Auth/AuthorizationPolicy";
import { formatDateForFilename } from "../../Utils/dates";
import { contactUploadButton } from "../../Layout/Buttons/PdsrUploadButton";
import { ContactUploadDialog } from "./ContactUploadDialog";

function ContactOverview() {
  const navigate = useNavigate();
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const addContact = () => navigate(contactUrls.addContact.uiPath);
  const editContact = (contact: ContactOverviewItem | undefined) =>
    contact && navigate(contactUrls.contactWithId(contact.Id).uiPath);

  const url = combinedUrls(contactUrls.base.apiUrl, "KendoGrid");

  const closeDialog = () => {
    setIsUploadDialogOpen(false);
  };

  return (
    <>
      <PageHeader headerText="Contact" />
      <SingleSelectKendoGrid
        localStorageKey="ContactOverviewGrid_DataState"
        fetchUrl={combinedUrls(contactUrls.base.apiUrl, "KendoGrid")}
        columns={ContactGridColumns()}
        idSelector={(contact: ContactOverviewItem) => contact.Id}
        toolbarItems={[
          defaultAddButton({
            onClick: addContact,
            roles: AuthorizationPolicies.RequireAdminNetworkRiskLaunchRoles,
          }),
          defaultEditButton({
            onClick: editContact,
            roles: AuthorizationPolicies.RequireAdminNetworkRiskLaunchRoles,
          }),
          contactUploadButton({
            onClick: () => setIsUploadDialogOpen(true),
            roles: AuthorizationPolicies.RequireAdminRole,
          }),
        ]}
        onRowDoubleClick={editContact}
        customToolbarItems={[
          createExportButton({ url, filename: `All_Contacts_${formatDateForFilename()}` }),
        ]}
      />
      <ContactUploadDialog isOpen={isUploadDialogOpen} closeDialog={closeDialog} />
    </>
  );
}

export default ContactOverview;
